import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  CustomInput,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../lib/moment.js'
import { url } from '../../constants'

class LeaveGenerationForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Leave Entitlement Generation
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <GenerationForm onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Leave Entitlement Year</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <CustomInputField
                            type="select"
                            id="year"
                            name="year"
                            value={ get(this.props, 'year') }
                            onChange={ this.props.handleInput }
                          >
                            {
                              get(this.props, 'years', []).map((s) => <option key={ shortid() } value={ s }>{ s }</option>)
                            }
                          </CustomInputField>
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Employee ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="emp_code"
                            disabled
                            value={ get(this.props, 'emp_code') }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Company</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="company"
                            disabled
                            value={ get(this.props, 'company') }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >LOB</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="lob"
                            disabled
                            value={ get(this.props, 'lob') }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Employee Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="name"
                            disabled
                            value={ get(this.props, 'name') }
                          />
                        </Col>
                      </Row>
                      {
                        get(this.props, 'leave_generations').map(gen => {
                          return (
                            <div>
                              <Row style={ { marginTop: 10, marginRight: 10, marginLeft: 1 } }>
                                <Label >{ gen.name }</Label>
                                <Row>
                                  <ColDate>
                                    <TextLabel >Start Date</TextLabel>
                                    <InputFieldDate
                                      autoComplete='off'
                                      id={ gen.leave_generation_id }
                                      name="start_date"
                                      type="date"
                                      disabled={ !get(this.props, 'isEdit') }
                                      value={ moment(gen.start_date).format('YYYY-MM-DD') }
                                      onChange={ this.props.handleInput }
                                    />
                                  </ColDate>
                                  <ColDate>
                                    <TextLabel >End Date</TextLabel>
                                    <InputFieldDate
                                      autoComplete='off'
                                      id={ gen.leave_generation_id }
                                      name="end_date"
                                      type="date"
                                      disabled={ !get(this.props, 'isEdit') }
                                      value={ moment(gen.end_date).format('YYYY-MM-DD') }
                                      onChange={ this.props.handleInput }
                                    />
                                  </ColDate>
                                  <ColNum>
                                    <TextLabel >Total</TextLabel>
                                    <InputFieldNum
                                      autoComplete='off'
                                      id={ gen.leave_generation_id }
                                      name="id"
                                      type='number'
                                      step='0.1'
                                      disabled={ !get(this.props, 'isEdit') }
                                      value={ gen.total }
                                      onChange={ this.props.handleInput }
                                    />
                                  </ColNum>
                                  <ColNum>
                                    <TextLabel >Used</TextLabel>
                                    <InputFieldNum
                                      disabled
                                      type='number'
                                      value={ gen.approved }
                                    />
                                  </ColNum>
                                  <ColNum>
                                    <TextLabel >Pending</TextLabel>
                                    <InputFieldNum
                                      disabled
                                      type='number'
                                      value={ gen.pending }
                                    />
                                  </ColNum>
                                  <ColNum>
                                    <TextLabel >Remaining</TextLabel>
                                    <InputFieldNum
                                      disabled
                                      type='number'
                                      value={ gen.remaining }
                                    />
                                  </ColNum>
                                </Row>
                              </Row>
                            </div>
                          )
                        })
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified Date</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated') ? moment(get(this.props, 'updated')).format('DD/MM/YYYY') : '-' }</p>
                            </Col>
                          </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified By</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated_by') ? get(this.props, 'updated_by') : '-' }</p>
                            </Col>
                          </Row>
                      }
                    </Container>
                  </FormGroup>
                  <Right>
                    { get(this.props, 'button') }
                  </Right>
                </GenerationForm>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

LeaveGenerationForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
LeaveGenerationForm.defaultProps = {
  handleInput: () => {},
}
export default LeaveGenerationForm

const GenerationForm = styled.div`
  overflow-y: scroll;
  max-height: calc(100vh - 220px);
`
const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
`
const InputFieldNum = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
`
const InputFieldDate = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 50% ;
  font-size: 12px ;
  ::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
  }
 `
const ColDate = styled(Col)`
  width : 26% ;
  height : 100% ;
  padding-right: 0px !important;
`
const ColNum = styled(Col)`
  width : 12% ;
  height : 55% ;
  padding-left: 10px !important;
  padding-right: 0px !important;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham' !important;
  font-size: 12px;
`
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`




// WEBPACK FOOTER //
// ./src/components/leave-generation/index.js